import { SET_BLOCKER_COUNT, SET_NOTIFICATIONS_DATA } from '../actions/notificationsActions';
import { MARK_AS_READ } from '../../../common/redux/NotificationsPanel/action';

const getModifiedData = (state, payload) => {
  const { notificationsData = {} } = state;
  const { data = {} } = notificationsData || {};
  const list = data;
  for (const key in list) {
    if (key === payload.type) {
      list[key].forEach((elem, index) => {
        if (elem.notificationId === payload?.notificationId) {
          elem.isRead = true;
          list[key].sort((a, b) => Number(a.isRead) - Number(b.isRead));
        }
      });
    }
  }
  return list;
};
export const notificationInitialState = {
  notificationsData: {},
  blockerNotificationsCount: 0,
  unReadCount: 0,
};
const notificationsReducer = (state = notificationInitialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATIONS_DATA:
      return {
        ...state,
        notificationsData: { ...action.payload },
      };
    case SET_BLOCKER_COUNT:
      return {
        ...state,
        blockerNotificationsCount: action.payload.blockerNotificationsCount,
        unReadCount: action.payload.unReadCount,
      };
    case MARK_AS_READ:
      return {
        ...state,
        notificationsData: {
          data: { ...getModifiedData(state, action.payload.data.notificationData) },
        },
        blockerNotificationsCount: action.payload.data.notificationData?.isMandatory
          ? action.payload.data.blockerNotificationsCount - 1
          : state.blockerNotificationsCount,
        unReadCount: action.payload.data.notificationData?.unReadCount || 0 - 1,
      };
    default:
      return state;
  }
};
export default notificationsReducer;
